import Icon from "./Icon";

const STATUS = {
  reserved: { label: "Rezervováno", icon: "lock", style: { background: "var(--warn)", color: "#241600" } },
  sold: { label: "Prodáno", icon: "x", style: { background: "#2a2e35", color: "var(--text)" } },
};

export default function StatusBadge({ status, className }) {
  const s = STATUS[status];
  if (!s) return null;
  return (
    <span className={`tag ${className || ""}`} style={s.style}>
      <Icon name={s.icon} size={13} strokeWidth={2.25} />
      {s.label}
    </span>
  );
}
